import { getCachedUserData } from "../utils/authSession";

export const getUserData = () => {
  return getCachedUserData();
};

export const getEnageUser = () => {
  try {
    const data = sessionStorage.getItem("engageData");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Failed to parse data:", error);
    return null;
  }
};

export const getUserRole = () => {
  return getUserData()?.role_value;
};

export const getOemNo = () => {
  return getUserData()?.oem_no;
};
export const getDealerNo = () => {
  return getUserData()?.dealer_no;
};
export const getCustomerNo = () => {
  return getUserData()?.customer_no;
};

export const hasRole = (...roles) => {
  const role = getUserRole();
  return roles.includes(role);
};
